import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../util/utils';

import {IconoirCustomMoreVerticalAlt} from '@ey-xd/motif-icon';

import Dropdown from '../../../../CoreWrappers/Dropdown';
import Button from '../../../../CoreWrappers/Button';

import EditEntityModal from '../EditEntityModal';

const EditEntity = ({entity, project, isDisabled = false, className = null}) => {
	const [showModal, setShowModal] = useState(false);

	const renderTrigger = () => {
		const props = {
			svg: IconoirCustomMoreVerticalAlt,
			variant: 'ghost'
		};

		return <Button {...props} />;
	};

	const items = [
		{
			id: 1,
			label: labels.editEntity,
			onClick: () => setShowModal(true),
			disabled: isDisabled
		}
	];

	const props = {
		id: `${entity.id}_dd`,
		placement: 'bottom-right',
		trigger: renderTrigger(),
		items,
		stableScroll: false,
		topfix: true,
		reversed: true
	};

	if (className) props.className = className;

	const editEntityModalProps = {
		entity,
		project,
		showModal,
		setShowModal
	};

	return (
		<div
			onClick={(e) => {
				e.stopPropagation();
			}}
		>
			<EditEntityModal {...editEntityModalProps} />
			<Dropdown {...props} />
		</div>
	);
};

EditEntity.propTypes = {
	isDisabled: PropTypes.bool
};

export default EditEntity;
